import React from 'react';

export default function CalendarSVG() {
  return (
    <svg
      height="1em"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.88672 0V2.8597"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M12.3032 0V2.8597"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M3.88683 0.789917H1V13.7558H12.5488L15 11.3317V0.789917H13.1202"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M12.5488 13.7558V11.3046H15"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M12.3032 0.789917H4.64966"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M1 4.65814H15"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M1 14.3271V14.7357H15V12.2845"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M4.22302 6.52893H2.55273V8.19922H4.22302V6.52893Z"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M7.27723 6.52893H5.60693V8.19922H7.27723V6.52893Z"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M10.3297 6.52893H8.65942V8.19922H10.3297V6.52893Z"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M4.22302 10.0685H2.55273V11.7388H4.22302V10.0685Z"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M7.27723 10.0685H5.60693V11.7388H7.27723V10.0685Z"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M10.3297 10.0685H8.65942V11.7388H10.3297V10.0685Z"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
      <path
        d="M13.4459 6.52893H11.7756V8.19922H13.4459V6.52893Z"
        stroke="currentColor"
        strokeWidth="0.452245"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
